<template>
  <div class="account-page-wrapper">
    <div class="account-main-content" :class="loggedIn ? loggedInTabs[state.selectedTabIndex].view : ''">
      <section>
        <h1 class="header">
          {{
            isForgotPw
              ? `${useTranslate('LoginPage.resetPassword')}`
              : isUpdatePw
              ? `${useTranslate('LoginPage.updatePassword')}`
              : !loggedIn
              ? useTranslate('LoginPage.signIn')
              : ''
          }}
        </h1>
        <div v-if="state.customerMessage" class="customer-message">
          {{ state.customerMessage }}
        </div>
        <div v-if="customerError" class="customer-error">
          {{ customerError }}
        </div>
      </section>
      <section v-if="isForgotPw" class="reset-password">
        <div class="info-text">
          {{ useTranslate('LoginPage.newPasswordText') }}
        </div>
        <Input
          variant="email"
          aria-autocomplete="both"
          autocomplete="email"
          name="Email"
          type="email"
          placeholder="Email"
          :label="useTranslate('GLOBALS.emailAddress')"
          emit-input="custom-input"
          @custom-input="state.email = $event.value"
        >
          {{ useTranslate('GLOBALS.emailAddress') }}
        </Input>
        <CustomButton :disabled="rootStore?.siteUnderMaintenance" @click-button="resetPassword()">
          {{ useTranslate('LoginPage.resetPassword') }}
        </CustomButton>
      </section>
      <!-- Change Pass -->
      <section v-else-if="isUpdatePw" class="reset-password">
        <div class="info-text">{{ useTranslate('LoginPage.updatePasswordReset') }}</div>
        <Input
          variant="password"
          aria-autocomplete="both"
          autocomplete="current-password"
          name="Password"
          :type="state.viewPasswordUpdate ? 'text' : 'password'"
          icon-position="right"
          placeholder="Password"
          label="Password"
          emit-input="custom-input"
          @custom-input="state.password = $event.value"
        >
          {{ useTranslate('GLOBALS.password') }}
          <template #icon>
            <EyeCloseLine
              v-if="state.viewPasswordUpdate"
              :aria-label="`${useTranslate('LoginPage.viewPassword')}`"
              role="button"
              @click="state.viewPasswordUpdate = !state.viewPasswordUpdate"
            />
            <EyeLine
              v-else
              :aria-label="`${useTranslate('LoginPage.hidePassword')}`"
              role="button"
              @click="state.viewPasswordUpdate = !state.viewPasswordUpdate"
            />
          </template>
        </Input>
        <Input
          variant="password"
          aria-autocomplete="both"
          autocomplete="current-password"
          :name="useTranslate('CreateAccount.confirmPassword')"
          :type="state.viewPasswordUpdateConfirm ? 'text' : 'password'"
          icon-position="right"
          :placeholder="useTranslate('CreateAccount.confirmPassword')"
          :label="useTranslate('CreateAccount.confirmPassword')"
          emit-input="custom-input"
          @custom-input="state.passwordConfirm = $event.value"
        >
          {{ useTranslate('CreateAccount.confirmPassword') }}
          <template #icon>
            <EyeCloseLine
              v-if="state.viewPasswordUpdateConfirm"
              :aria-label="`${useTranslate('LoginPage.viewPassword')}`"
              role="button"
              @click="state.viewPasswordUpdateConfirm = !state.viewPasswordUpdateConfirm"
            />
            <EyeLine
              v-else
              :aria-label="`${useTranslate('LoginPage.hidePassword')}`"
              role="button"
              @click="state.viewPasswordUpdateConfirm = !state.viewPasswordUpdateConfirm"
            />
          </template>
        </Input>
        <CustomButton :disabled="rootStore?.siteUnderMaintenance" @click-button="changePassword()">
          {{ useTranslate('LoginPage.updatePassword') }}
        </CustomButton>
      </section>
      <!-- Change Pass -->
      <section v-else class="content">
        <div v-if="loggedIn" class="logged-in-content">
          <h1 class="header">
            {{ loggedInTabs[state.selectedTabIndex].title }}
          </h1>
          <nav class="account-items desk-hor-mob-col cntr">
            <div
              v-for="(item, index) in loggedInTabs"
              :key="item.title"
              :class="[{ 'selected ul': index === state.selectedTabIndex }, 'pointer']"
              @click="item.view !== 'logout' ? setIndex(index) : {}"
            >
              <h3 v-if="item.view !== 'logout'">
                {{ item.title }}
              </h3>
              <h3
                v-else
                role="button"
                :aria-label="`${useTranslate('AccountPage.logoutAccount')}`"
                :title="`${useTranslate('AccountPage.logoutAccount')}`"
                @click="state.promptConfirmLogout = true"
              >
                {{ item.title }}
              </h3>
            </div>
          </nav>

          <div v-if="loggedInTabs[state.selectedTabIndex].view === 'account'" class="acc-details mgn-top-1">
            <div class="label">{{ useTranslate('GLOBALS.name') }}:</div>
            <span class="info">{{ customer?.first_name }} {{ customer?.last_name }}</span>
            <div class="label">{{ useTranslate('GLOBALS.email') }}:</div>
            <span class="info">{{ customer?.email }}</span>
            <div class="label">{{ useTranslate('GLOBALS.phone') }}:</div>
            <span class="info">{{ customer?.phone }}</span>
          </div>
          <AccountOrders v-else-if="loggedInTabs[state.selectedTabIndex].view === 'orders'" />
          <RecentlyViewed v-else-if="loggedInTabs[state.selectedTabIndex].view === 'recentlyviewed'" />
          <MentionMe v-else-if="loggedInTabs[state.selectedTabIndex].view === 'referrals'" render-type="dashboard" />
        </div>
        <div v-else id="login-form-row" class="login-row flex-inline desk-hor-mob-col">
          <form class="login-form form" method="POST" @submit.prevent="loginAction()">
            <Input
              variant="email"
              aria-autocomplete="both"
              autocomplete="email"
              name="Email"
              type="email"
              placeholder="Email"
              :label="useTranslate('GLOBALS.emailAddress')"
              emit-input="custom-input"
              @custom-input="state.email = $event.value"
            >
              {{ useTranslate('GLOBALS.emailAddress') }}
            </Input>

            <Input
              variant="password"
              aria-autocomplete="both"
              autocomplete="current-password"
              name="Password"
              :type="state.viewPasswordLogin ? 'text' : 'password'"
              icon-position="right"
              :placeholder="useTranslate('GLOBALS.password')"
              :label="useTranslate('GLOBALS.password')"
              emit-input="custom-input"
              @custom-input="state.password = $event.value"
            >
              {{ useTranslate('GLOBALS.password') }}
              <template #icon>
                <EyeCloseLine
                  v-if="state.viewPasswordLogin"
                  :aria-label="`${useTranslate('LoginPage.viewPassword')}`"
                  role="button"
                  @click="state.viewPasswordLogin = !state.viewPasswordLogin"
                />
                <EyeLine
                  v-else
                  :aria-label="`${useTranslate('LoginPage.hidePassword')}`"
                  role="button"
                  @click="state.viewPasswordLogin = !state.viewPasswordLogin"
                />
              </template>
            </Input>

            <div class="form-actions flex-col cntr">
              <CustomButton :disabled="rootStore?.siteUnderMaintenance" type="submit">{{
                useTranslate('LoginPage.signIn')
              }}</CustomButton>
              <NuxtLink
                class="forgot-password"
                :to="localePath({ name: 'account', query: { action: 'reset-password' } })"
                >{{ useTranslate('LoginPage.forgotPassword') }}</NuxtLink
              >
            </div>
          </form>

          <div class="new-customer">
            <div class="panel">
              <div class="panel-header">
                <h2 class="panel-title">{{ useTranslate('LoginPage.newCustomer') }}</h2>
              </div>
              <div class="panel-body flex-col cntr">
                <p class="new-customer-intro">{{ useTranslate('LoginPage.accountBenefits') }}</p>
                <ul class="new-customer-fact-list">
                  <li class="new-customer-fact">{{ useTranslate('LoginPage.fastCheckout') }}</li>
                  <li class="new-customer-fact">{{ useTranslate('AccountPage.multipleShipping') }}</li>
                  <li class="new-customer-fact">{{ useTranslate('LoginPage.orderHistory') }}</li>
                  <li class="new-customer-fact">{{ useTranslate('LoginPage.trackOrders') }}</li>
                  <li v-if="useTranslate('LoginPage.saveToWishList')" class="new-customer-fact">
                    {{ useTranslate('LoginPage.saveToWishList') }}
                  </li>
                </ul>
                <CustomButton :disabled="rootStore?.siteUnderMaintenance" :to="localePath('/create-account')">
                  {{ useTranslate('LoginPage.createAccount') }}
                </CustomButton>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <ModalWindow
      v-if="state.promptConfirmLogout"
      class="modal-confirm-logout"
      @closed="state.promptConfirmLogout = false"
    >
      <section>
        <h4>{{ useTranslate('AccountPage.confirmLogout') }}</h4>
        <div class="button-group">
          <CustomButton style-name="primary" style-color="black" class="save-button" @click-button="confirmLogout">{{
            useTranslate('AccountPage.logoutAccount')
          }}</CustomButton>
          <CustomButton
            style-name="tertiary"
            style-color="black"
            class="main-link"
            @click-button="state.promptConfirmLogout = false"
            >Cancel</CustomButton
          >
        </div>
      </section>
    </ModalWindow>
  </div>
</template>

<script setup lang="ts">
import { useCustomerStore } from '~/store/customer';
import { metaGen } from '~/util/metadata';
import { emailValid } from '~/util/string';
import { useRootStore } from '~/store';
import { useLocaleStore } from '~/store/locale';
import { mapAccountDataToGtmEvent, GtmEventType } from '~/util/analytics';

const localePath = useLocalePath();
const customerStore = useCustomerStore();
const rootStore = useRootStore();
const localeStore = useLocaleStore();
const route = useRoute();
const messages = {
  confirmLogout: useTranslate('AccountPage.confirmLogout'),
  loginForCart: useTranslate('AccountPage.loginForCart'),
  resetPasswordMessage: useTranslate('AccountPage.resetPasswordMessage'),
  resetPasswordWrongEmail: useTranslate('AccountPage.resetPasswordWrongEmail'),
  updatedPassword: useTranslate('AccountPage.updatedPassword'),
  updatedPasswordFail: useTranslate('AccountPage.updatedPasswordFail'),
};

const state = reactive({
  selectedTabIndex: 0,
  email: '',
  password: '',
  passwordConfirm: '',
  customerMessage: '',
  redirectToCart: false,
  viewPasswordLogin: false,
  viewPasswordUpdate: false,
  viewPasswordUpdateConfirm: false,
  promptConfirmLogout: false,
});

const loggedInTabs = computed(() => {
  type Tab = { title: string; view: string };
  const loggedInTabs: Tab[] = [
    { title: useTranslate('AccountPage.orders'), view: 'orders' },
    { title: 'Account', view: 'account' },
    { title: useTranslate('AccountPage.recentlyViewed'), view: 'recentlyviewed' },
    { title: 'Referrals', view: 'referrals' },
    { title: useTranslate('AccountPage.logout'), view: 'logout' },
  ];

  if (!localeStore?.isUsLocale) {
    // If not US locale, filter out 'Referrals'
    return loggedInTabs.filter((tab) => tab.view !== 'referrals');
  }

  return loggedInTabs;
});
const customerError = computed(() => customerStore.customerError);
const loggedIn = computed(() => customerStore.loggedIn);
const customer = computed(() => customerStore.customer);
const isPasswordUpdated = computed(() => customerStore.isPasswordUpdated);
const action = computed(() => route?.query?.action as string);
const isForgotPw = computed(() => action.value === 'reset-password');
const isUpdatePw = computed(() => action.value === 'update-password');
const redirectUrl = computed(() => route?.query?.redirect as string);

onMounted(async () => {
  await setDraftMessage();
});

async function confirmLogout() {
  await useLogout();
  setIndex(0);
  state.promptConfirmLogout = false;
}
async function loginAction() {
  await useLogin({
    email: state.email,
    password: state.password,
  });
  const loginDetails = {
    email: state.email,
  };
  const gtm = useGtm();
  gtm?.trackEvent(mapAccountDataToGtmEvent(GtmEventType.login, loginDetails));
  if (loggedIn.value && redirectUrl.value) {
    await navigateTo(redirectUrl.value);
  }
}
async function setDraftMessage() {
  if (route?.query?.action === 'loadSavedQuote') {
    state.customerMessage = messages.loginForCart;
    state.redirectToCart = true;
    await navigateTo(localePath({ path: '/account', query: { redirect: '/cart' } }));
  }
}
async function resetPassword() {
  const email = state.email;
  if (email !== '' && emailValid(email)) {
    await useHandlePasswordReset({
      email,
    });
    state.customerMessage = messages.resetPasswordMessage;
  } else {
    state.customerMessage = messages.resetPasswordWrongEmail;
  }
}
async function changePassword() {
  try {
    const token = route.query.token;
    if (state.password === state.passwordConfirm) {
      const data = {
        password: state.password,
        passwordConfirm: state.passwordConfirm,
        hashedCustomerId: token,
      };
      await useUpdatePassword(data);
      if (isPasswordUpdated.value) {
        await navigateTo(localePath('/account'));
        state.customerMessage = messages.updatedPassword;
      }
    } else {
      state.customerMessage = messages.updatedPasswordFail;
    }
  } catch (error) {
    console.error(error); // eslint-disable-line no-console
    Promise.resolve(error);
  }
}
function setIndex(index: number) {
  state.selectedTabIndex = index;
}
// TODO - CTS SEO META
const metaGenCustom = metaGen(rootStore?.brandSettings, {
  page_title: useTranslate('AccountPage.pageSEO'),
}) as any;
useHead({
  ...metaGenCustom,
});
</script>

<style lang="scss" scoped>
.account-page-wrapper {
  padding-top: 1rem;
}
.account-main-content {
  justify-content: space-between;
  margin: 0 auto;
  max-width: 66.66667rem;
  width: 100%;
  @include local-mixins.tablet_and_mobile {
    max-width: 100%;
  }
}
.acc-details {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 1rem;
  width: min-content;
  margin: 1rem auto;
  @include local-mixins.desktop {
    margin: 1.5rem auto;
  }
  .label {
    font-weight: 500;
  }
  .label,
  .info {
    line-height: 1.5;
    font-size: 1.25rem;
  }
}
.content {
  .login-form,
  .new-customer {
    width: 50%;
    @include local-mixins.tablet_and_mobile {
      width: 100%;
    }
  }
  .login-form {
    @include local-mixins.desktop {
      margin-right: 1rem;
    }
    @include local-mixins.tablet_and_mobile {
      margin-bottom: 1rem;
    }
  }
}
.logged-in-content {
  .account-items {
    display: flex;
    justify-content: space-evenly;
    margin-bottom: 1rem;
    h3 {
      font-size: 1.125rem;
      line-height: 1.5rem;
      font-weight: 100;
    }
  }
}
.reset-password {
  .info-text,
  .input-component-container {
    margin-bottom: 0.75rem;
  }
}
.customer-message,
.customer-error {
  padding: 0.75rem;
  width: 100%;
  border-radius: 5px;
  margin-bottom: 1rem;
}
.customer-message {
  border: 1px solid $color-warning-dark;
  background-color: $color-warning-light;
  color: $color-warning-dark;
}
.customer-error {
  border: 1px solid $color-danger-dark;
  background-color: $color-danger-light;
  color: $color-danger-dark;
}
.form-actions {
  margin-top: 1rem;
  .forgot-password {
    margin-top: 1rem;
    color: $color-neutral-cool-700;
  }
}
.input-component-container {
  + .input-component-container {
    margin-top: 1.25rem;
  }
}
.header,
.panel-title {
  text-align: center;
}
ul {
  list-style: disc;
}
.new-customer {
  background-color: $color-neutral-cool-50;
  padding: 20px 28px;
  border-radius: 4px;
}
.new-customer-fact-list {
  margin-bottom: 20px;
}
.new-customer-fact {
  padding-left: 0.66667rem;
}
:deep(.modal-confirm-logout) {
  .modal-content {
    min-height: 25vh;
    max-width: #{local-functions.rem-calc(340)};
    padding: #{local-functions.rem-calc(65)} #{local-functions.rem-calc(25)} #{local-functions.rem-calc(25)};
  }
  h4 {
    margin-bottom: #{local-functions.rem-calc(10)};
  }
  .button-group {
    display: flex;
    justify-content: space-between;
  }
}
</style>
